<script setup>
import { ref, computed, onMounted } from "vue";
import { useI18n } from 'vue-i18n'
import { useEnvStore } from "@dutypay/front-end-design-system/src/stores";
import PageContainerFooter from "./PageContainerFooter.vue";

const { locale } = useI18n({ useScope: "global" });
const envStore = useEnvStore();
const assetsApiEndpoint = computed(() => {
  return `${envStore.apiUrls.dutypay}/api/v0/assets`;
});

const isJurisdictionSelectorShown = ref(false);

onMounted(() => {
  function resizeViewportHeight() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  resizeViewportHeight();
  window.addEventListener("resize", () => {
    resizeViewportHeight();
  });
})
</script>
<script>
  export default {
    name: 'PageContainer'
  };
</script>

<template>
  <div class="page-container">
        <div class="dp-flex column justify-content__space-between">
            <div class="header">
                <div class="application-logo-wrapper">
                    <a :href="`https://www.dutypay.eu/${ locale }`"
                        target="_blank"
                        rel="noopener">
                        <img
                            :src="`${assetsApiEndpoint}/logo/dutypay/standard/light/svg`"
                            alt="DutyPay"
                            class="application-logo speak-never" />
                    </a>
                    <div
                        class="jurisdiction-select__trigger dp-flex"
                        tabindex="0"
                        @click="isJurisdictionSelectorShown = !isJurisdictionSelectorShown">
                        <DpFlag :flagISOCode="locale.slice(-2)" />
                        <DpIcon
                            :icon="isJurisdictionSelectorShown ? 'chevron-block-start' : 'chevron-block-end'"
                            :margin="false" />
                    </div>
                </div>
                <DpExpand>
                    <div
                        class="dp-nest outlined depth-0"
                        v-if="isJurisdictionSelectorShown">
                        <DpJurisdictionSelector @select="isJurisdictionSelectorShown = false" />
                    </div>
                </DpExpand>
            </div>
        </div>
        <div class="page-container--narrow dp-flex column justify-content__space-between">
            <div>
                <div class="content">
                    <slot></slot>
                </div>
            </div>
            <div class="footer">
                <slot name="footer"></slot>
            </div>
        </div>
        <PageContainerFooter />
    </div>
</template>

<i18n>{}</i18n>

<style lang="scss">
.page-container {
    min-height: calc(var(--vh, 1vh) * 100); // Adjustment for iOS screen height
    color: #ffffff;
    max-width: 1000px;
    width: 100%;

    h1, h2, h3, h4, h5, h6, p,
    a, a:hover, a:focus, a:visited, a:active {
      color: #FFFFFF;
    }

    .header {
        color: #525252 !important;
    }

    h2 {
      margin-bottom: 1rem;
    }

    .application-logo {
      width: auto;
      height: 32px;
    }
}
  
// Light font on dark background
.redirect-message {
    text-align: center;
    color: #ffffff;
}


button.dp-button {
    width: 100%;
    font-size: 1rem;
}
</style>

<style scoped lang="scss">
@media screen and (max-width: 768px) {
    .page-container .footer a {
        display: block;
        margin: 0;
    }
}

.page-container {
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    &--narrow {
        max-width: 480px;
        margin: 0 auto;
        flex-grow: 1;
        justify-content: center;
        width: 100%;
    }
    .header {
        margin: 1.5rem auto;
    }
    .application-logo-wrapper {
        position: relative;
        height: 32px;
        width: 146px;
        margin: 0 auto;
    }

    .content {
        margin: 1.5rem auto;
        padding: 0 1.5rem;
    }


}

.jurisdiction-select__trigger {
    position: absolute;
    margin-inline-start: 0.5rem;
    transform: translateY(1.2rem);
    padding: 0.33rem 0.5rem;
    bottom: 0;
    left: 100%;
    color: #ffffff !important;
    cursor: pointer;

    i {
        opacity: 0;
        transition: opacity 50ms ease-in;
    }

    &:hover {
        i {
            opacity: 1;
        }
    }
}
</style>
